<script>
import Layout from "@/views/layouts/default";
import appConfig from "@/app.config";
import Cookie from "js-cookie";
import StarRating from "vue-star-rating";
import Statistic from '@/components/statistic';

export default {
  page: {
    title: "Dashboard",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Layout,
    StarRating,
    Statistic,
  },
  data() {
    return {
      account: null,
      ratings: [],
      counter: {
        menunggu_penawaran: 0,
        proses_negosiasi: 0,
        menunggu_pembayaran: 0,
        menunggu_assign_driver: 0,
        menunggu_dokumen: 0,
        menunggu_pickup: 0,
        proses_pickup: 0,
        proses_pengiriman: 0,
        unloading: 0,
        payment: 0,
        selesai: 0,
        batal: 0,
      },
      driver: {
        total: 0,
        available: 0,
        onduty: 0
      },
      active: 1,
      driverDeals: [],
      driverOrders: [],
      truckOwnerDeals: [],
      truckOwnerOrders: [],
      summary: {
        totalOfferFinishedJob: 0,
        totalOfferCanceledJob: 0,
        totalOffer: 0,
        countOfferFinishedJob: 0,
        countOfferCanceledJob: 0,
        countOffer: 0
      }
    };
  },
  mounted() {
    this.getProfile()
    this.getRating()
    this.getSummary()
    this.getCounter()
    this.getDriver()
    this.getDriverDeal()
    this.getDriverOrder()
    this.getTructOwnerDeal()
    this.getTructOwnerOrder()
  },
  methods: {
    forceLogout() {
      this.$refs.modalAccount.hide();
      Cookie.remove("userdata");
      this.$store.commit("SET_LOGIN", null);
      this.$router.push("/login");
    },
    getProfile() {
      this.$axios.get('/v1/logistic_company/auth/profile')
        .then(response => {
          const lc = response.data.data.logistic_company
          this.account = lc
          if (lc.document_status === 'ditolak') {
            this.isError = true
            this.errorMessage = `Dokumen legalitas Anda ditolak dengan alasan ${lc.reject_reason}`
          }
          if (lc.account_status !== 'aktif' || lc.document_status === 'ditolak') {
            this.$refs.modalAccount.show();
          }
        })
    },
    getRating() {
      this.$axios.get('/v1/logistic_company/auth/rating', {
        params: {
          page: 1,
          per_page: 3,
          orderby: 'id',
          sort: 'desc'
        }
      })
        .then(response => {
          this.ratings = response.data.data.rows
        })
    },
    getSummary() {
      this.$axios.get('/v1/logistic_company/dashboard/get_offer')
        .then(result => {
          this.summary = result.data.data
        })
    },
    getCounter() {
      this.$axios.get('/v1/logistic_company/job/counter')
        .then(result => {
          result.data.data.forEach(data => {
            switch (data.status) {
              case 1:
                this.counter.menunggu_penawaran = data.total
                break;
              case 2:
                this.counter.proses_negosiasi = data.total
                break;
              case 3:
                this.counter.menunggu_pembayaran = data.total
                break;
              case 4:
                this.counter.menunggu_assign_driver = data.total
                break;
              case 5:
                this.counter.menunggu_dokumen = data.total
                break;
              case 6:
                this.counter.menunggu_pickup = data.total
                break;
              case 7:
                this.counter.proses_pickup = data.total
                break;
              case 8:
                this.counter.proses_pengiriman = data.total
                break;
              case 9:
                this.counter.unloading = data.total
                break;
              case 10:
                this.counter.payment = data.total
                break;
              case 11:
                this.counter.selesai = data.total
                break;
              case 12:
                this.counter.batal = data.total
                break;
            }
          })
        })
    },
    getDriver() {
      this.$axios.get('/v1/logistic_company/dashboard/get_driver_summary')
        .then(result => {
          this.driver = {
            total: result.data.data.totalDriver,
            available: result.data.data.totalDriverTersedia,
            onduty: result.data.data.totalDriverBerjalan
          }
        })
    },
    getDriverDeal() {
      this.$axios.get('/v1/logistic_company/dashboard/get_driver_deal_statistic')
        .then(result => {
          this.driverDeals = result.data.data
        })
    },
    getDriverOrder() {
      this.$axios.get('/v1/logistic_company/dashboard/get_driver_order_statistic')
        .then(result => {
          this.driverOrders = result.data.data
        })
    },
    getTructOwnerDeal() {
      this.$axios.get('/v1/logistic_company/dashboard/get_to_deal_statistic')
        .then(result => {
          this.truckOwnerDeals = result.data.data
        })
    },
    getTructOwnerOrder() {
      this.$axios.get('/v1/logistic_company/dashboard/get_to_order_statistic')
        .then(result => {
          this.truckOwnerOrders = result.data.data
        })
    },
  }
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-lg-2">
        <div class="page-title-box pb-2">
          <h4 class="font-size-18">Profile</h4>
        </div>
        <div class="card p-3 pr-4 rounded">
          <div class="d-flex" style="margin: auto; padding-top: 5px">
            <b-img :src="require('@/assets/images/dashboard/rating.png')" height="50" />
            <div id="rating-desc" style="margin-left: 15px">
              <p class="text-muted font-weight-normal mb-1">Rating</p>
              <div class="font-size-24 font-weight-bolder">{{ account.rating || 0 }}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- end col -->
      <div class="col-lg-10">
        <div class="page-title-box mb-3 pb-2">
          <p>
            <router-link to="/rating" class="float-right text-danger">
              Lihat Semua
            </router-link>
          </p>
        </div>
        <div class="row">
          <div v-for="(rating, index) in ratings" :key="index" class="col-lg-4">
            <div class="card rounded px-3 py-2" style="min-height: 100px">
              <div class="d-flex justify-content-between">
                <div class="rating-start">
                  <star-rating :increment="0.5" :show-rating="false" :rounded-corners="true" :rating="rating.rating" :star-size="22" :padding="2" :read-only="true"></star-rating>
                </div>
                <div class="timestamp-desc">
                  <p class="text-muted font-weight-normal font-size-12">
                    {{ rating.created_at | date_only }}
                  </p>
                </div>
              </div>
              <div class="rating-comment">
                {{ rating.comment }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->

    <div class="row">
      <div class="col-lg-6">
        <div class="row">
          <div class="col-lg-12">
            <div class="page-title-box pb-2">
              <h4 class="font-size-18">Value Penawaran</h4>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <div class="card p-3 pr-4 rounded">
                  <div class="d-flex align-items-center">
                    <b-img :src="require('@/assets/images/dashboard/salam-hijau.png')" height="50" />
                    <div id="rating-desc" style="margin-left: 15px">
                      <p class="text-muted font-weight-normal mb-1 mt-2 font-size-16">Total Value Penawaran</p>
                    </div>
                  </div>
                  <div class="font-weight-bolder font-size-24 mt-3 mb-2">
                    Rp. {{ summary.totalOffer | convertToRupiah }}
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="card px-3 py-1 pr-3 mb-3 rounded">
                  <div class="d-flex justify-content-between align-items-center">
                    <div class="d-flex align-items-center">
                      <b-img :src="require('@/assets/images/dashboard/salam-kuning.png')" height="35" />
                      <p class="text-muted font-weight-normal ml-2 mt-3 font-size-14">Deal</p>
                    </div>
                    <div id="rating-desc mt-4">
                      <p class="font-size-14 font-weight-bolder mb-0">Rp. {{ summary.totalOfferFinishedJob | convertToRupiah }}</p>
                    </div>
                  </div>
                </div>
                <div class="card px-3 py-1 pr-3 mb-1 rounded">
                  <div class="d-flex justify-content-between align-items-center">
                    <div class="d-flex align-items-center">
                      <b-img :src="require('@/assets/images/dashboard/salam-abu-abu.png')" height="35" />
                      <p class="text-muted font-weight-normal ml-2 mt-3 font-size-14">Tidak Deal</p>
                    </div>
                    <div id="rating-desc mt-4">
                      <p class="font-size-14 font-weight-bolder mb-0">Rp. {{ summary.totalOfferCanceledJob | convertToRupiah }}</p>
                    </div>
                  </div>
                </div>
                
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="row">
          <div class="col-lg-12">
            <div class="page-title-box pb-2">
              <h4 class="font-size-18">Penawaran</h4>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <div class="card p-3 pr-4 rounded">
                  <div class="d-flex align-items-center">
                    <b-img :src="require('@/assets/images/dashboard/salam-biru.png')" height="50" />
                    <div id="rating-desc" style="margin-left: 15px">
                      <p class="text-muted font-weight-normal mb-1 mt-2 font-size-16">Total Penawaran</p>
                    </div>
                  </div>
                  <div class="font-weight-bolder text-center font-size-24 mt-3 mb-2">
                    {{ summary.countOffer }}
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="card px-3 py-1 pr-3 mb-3 rounded">
                  <div class="d-flex justify-content-between align-items-center">
                    <div class="d-flex align-items-center">
                      <b-img :src="require('@/assets/images/dashboard/salam-biru.png')" height="35" />
                      <p class="text-muted font-weight-normal ml-2 mt-3 font-size-14">Deal</p>
                    </div>
                    <div id="rating-desc mt-4">
                      <p class="font-size-14 font-weight-bolder mb-0">{{ summary.countOfferFinishedJob }}</p>
                    </div>
                  </div>
                </div>
                <div class="card px-3 py-1 pr-3 mb-1 rounded">
                  <div class="d-flex justify-content-between align-items-center">
                    <div class="d-flex align-items-center">
                      <b-img :src="require('@/assets/images/dashboard/salam-abu-abu.png')" height="35" />
                      <p class="text-muted font-weight-normal ml-2 mt-3 font-size-14">Tidak Deal</p>
                    </div>
                    <div id="rating-desc mt-4">
                      <p class="font-size-14 font-weight-bolder mb-0">{{ summary.countOfferCanceledJob }}</p>
                    </div>
                  </div>
                </div>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->

    <div class="row">
      <div class="col-lg-12">
        <div class="page-title-box pb-2">
          <h4 class="font-size-18">Need Action</h4>
        </div>
      </div>
      <!-- end col -->
      <div class="col-lg-3">
        <div class="card px-2 py-3 rounded">
          <div class="d-flex">
            <b-img :src="require('@/assets/images/dashboard/note-kuning.png')" height="40" />
            <div id="rating-desc" style="margin-left: 15px">
              <p class="text-muted font-weight-normal mb-1">Menunggu Pembayaran</p>
              <p class="font-size-24 font-weight-bolder mb-0">{{ counter.menunggu_pembayaran }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-3">
        <div class="card px-2 py-3 rounded">
          <div class="d-flex">
            <b-img :src="require('@/assets/images/dashboard/note-biru.png')" height="40" />
            <div id="rating-desc" style="margin-left: 15px">
              <p class="text-muted font-weight-normal mb-1">Menunggu Dokumen</p>
              <p class="font-size-24 font-weight-bolder mb-0">{{ counter.menunggu_dokumen }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-3">
        <div class="card px-2 py-3 rounded">
          <div class="d-flex">
            <b-img :src="require('@/assets/images/dashboard/note-hijau.png')" height="40" />
            <div id="rating-desc" style="margin-left: 15px">
              <p class="text-muted font-weight-normal mb-1">Menunggu Verifikasi Dok</p>
              <p class="font-size-24 font-weight-bolder mb-0">{{ counter.payment }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
    

    <div class="row">
      <div class="col-lg-12">
        <div class="page-title-box pb-2">
          <h4 class="font-size-18">Driver</h4>
        </div>
      </div>
      <!-- end col -->
      <div class="col-lg-3">
        <div class="card px-2 py-3 rounded">
          <div class="d-flex">
            <b-img :src="require('@/assets/images/dashboard/truck-merah.png')" height="40" />
            <div id="rating-desc" style="margin-left: 15px">
              <p class="text-muted font-weight-normal mb-1">Total Driver</p>
              <p class="font-size-24 font-weight-bolder mb-0">{{ driver.total }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-3">
        <div class="card px-2 py-3 rounded">
          <div class="d-flex">
            <b-img :src="require('@/assets/images/dashboard/truck-hijau.png')" height="40" />
            <div id="rating-desc" style="margin-left: 15px">
              <p class="text-muted font-weight-normal mb-1">Tersedia</p>
              <p class="font-size-24 font-weight-bolder mb-0">{{ driver.available }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-3">
        <div class="card px-2 py-3 rounded">
          <div class="d-flex">
            <b-img :src="require('@/assets/images/dashboard/truck-biru.png')" height="40" />
            <div id="rating-desc" style="margin-left: 15px">
              <p class="text-muted font-weight-normal mb-1">Berjalan</p>
              <p class="font-size-24 font-weight-bolder mb-0">{{ driver.onduty }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->

    <div class="row mb-3">
      <div class="col-lg-12">
        <div class="page-title-box pb-2">
          <h4 class="font-size-18">Statistik</h4>
        </div>
        <div class="d-flex">
          <b-button type="button" @click="active = 1" :variant="active == 1 ? 'outline-danger' : 'outline-secondary'" class="mr-2 font-weight-bold btn-lg">Truck Owner</b-button>
          <b-button type="button" @click="active = 2" :variant="active == 2 ? 'outline-danger' : 'outline-secondary'" class="mr-2 font-weight-bold btn-lg">Truck Driver</b-button>
        </div>
      </div>
    </div>
    <!-- end row -->

    <div class="row" v-if="active == 1">
      <div class="col-lg-6">
        <h4 class="font-size-18">Total Deal</h4>
        <Statistic type="Deal" :statistics="truckOwnerDeals" />
      </div>
      <div class="col-lg-6">
        <h4 class="font-size-18">Repeat Order</h4>
        <Statistic type="Order" :statistics="truckOwnerOrders" />
      </div>
    </div>
    <div class="row" v-if="active == 2">
      <div class="col-lg-6">
        <h4 class="font-size-18">Total Deal</h4>
        <Statistic type="Deal" :statistics="driverDeals" />
      </div>
      <div class="col-lg-6">
        <h4 class="font-size-18">Repeat Order</h4>
        <Statistic type="Order" :statistics="driverOrders" />
      </div>
    </div>
    <!-- end row -->

    <!-- modal account -->
    <b-modal title="Warning" ref="modalAccount" id="modal-account" hide-footer no-close-on-esc no-close-on-backdrop>
      <div class="row">
        <div class="col-lg-12 text-center font-size-24 font-weight-bold" v-if="account">
          <div v-if="account.account_status !== 'aktif'">
            Akun Anda tidak dapat diakses karena status akun Anda telah <span class="text-danger">{{ account.account_status }}</span>, silakan hubungi Admin
          </div>
          <div v-else-if="account.document_status == 'ditolak'">
            Akun Anda tidak dapat diakses karena dokumen legalitas Anda telah ditolak dengan alasan <span class="text-danger">{{ account.reject_reason }}</span>, silakan hubungi Admin
          </div>
        </div>

        <div class="w-100 d-flex justify-content-around mt-3">
          <b-button type="button" class="w-50" variant="danger" @click="forceLogout">OK</b-button>
        </div>
      </div>
    </b-modal>
    <!-- / modal-->
  </Layout>
</template>

<style scoped>
.icon-panah {
  position: absolute;
  top: 35%;
  left: 0%;
}
.content-slider {
  position: relative;
}
.nav-kiri {
  cursor: pointer;
  position: absolute;
  top: 45%;
  left: 5%;
}
.nav-kanan {
  cursor: pointer;
  position: absolute;
  top: 45%;
  right: 5%;
}

.total-job {
  position: absolute;
  top: 25%;
  right: 50%;
}

.card-body {
  padding: 5px 15px !important;
}

.border-light {
  border-color: #e9ecef!important;
}
</style>